import { useRef } from "react";
import { Button, Card, HowareuLogo } from "@ptsd/uikit";
import { Anchor, Text, useMedia, XStack, YStack } from "tamagui";

export const Howareu = () => {
  const { gtMd } = useMedia();

  return (
    <Card
      data-id={"howareu-container"}
      shadow={"md"}
      size={"sm"}
      gap={"$3"}
      $gtSm={{ size: "md", gap: "$0.5" }}
    >
      <Card.Title paddingBottom={"$1"} textAlign={gtMd ? "center" : "left"}>
        Допомога від наших партнерів
      </Card.Title>
      <XStack
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        paddingBottom={"$2"}
        gap={"$1"}
        $gtMd={{
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <HowareuLogo />
        <Text
          fontFamily={"$howareu"}
          lineHeight={"$6.5"}
          textAlign={"left"}
          fontWeight={"400"}
          fontSize={20}
          $gtMd={{ fontSize: "$4", textAlign: "center" }}
          style={{ textWrapStyle: "balance" } as React.CSSProperties}
        >
          {"Всеукраїнська програма ментального здоров'я"}
        </Text>
      </XStack>
      <YStack gap={"$2"}>
        <LinkBlock
          title={"Самодопомога"}
          subtitle={"Інструменти для управління стресом та плекання стійкості"}
          href={"https://howareu.com/self-help"}
        />
        <LinkBlock
          title={"Корисні матеріали"}
          subtitle={
            "Просто про складне у матеріалах, підготовлених експертами «Ти як?»"
          }
          href={"https://howareu.com/materials"}
        />
        <LinkBlock
          title={"Продукти, створені у межах «Ти як?»"}
          subtitle={
            "Практичні інструменти для піклування про ментальне здоров'я та плекання стійкості"
          }
          href={"https://howareu.com/produkty"}
        />
      </YStack>
    </Card>
  );
};

const LinkBlock = ({
  title,
  subtitle,
  href,
}: {
  title: string;
  subtitle: string;
  href: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <XStack
      ref={ref}
      flexDirection={"column"}
      $gtMd={{
        flexDirection: "row",
        paddingVertical: "$4",
        paddingHorizontal: "$5",
      }}
      gap={"$4"}
      paddingVertical={"$3"}
      justifyContent={"space-between"}
      paddingHorizontal={"$3"}
      backgroundColor={"$warm-snow-500"}
      borderStyle={"solid"}
      borderRadius={"$9"}
      borderColor={"$gray-600"}
      borderWidth={"$0.1"}
    >
      <YStack flex={1} gap={"$1"}>
        <Text fontSize={"$3"} fontWeight={"600"} fontFamily={"$body"}>
          {title}
        </Text>
        <Text fontSize={"$2"} fontWeight={"500"} fontFamily={"$body"}>
          {subtitle}
        </Text>
      </YStack>
      <YStack>
        <Anchor href={href} textDecorationLine="none" target={"_blank"} asChild>
          <Button
            variant={"outlined"}
            size={"md"}
            rounded={"xl"}
            minWidth={ref.current && ref.current.clientWidth > 1000 ? 200 : 140}
          >
            Переглянути
          </Button>
        </Anchor>
      </YStack>
    </XStack>
  );
};
